<template>
  <q-page padding>
    <base-list></base-list>
  </q-page>
</template>

<script>
export default {
  name: 'List'
}
</script>
